<script>
  import router from "page"

  // Include our Routes
  import Bmi from './bmi/bmi.svelte'
	import Default from './default.svelte'
  import Pdq8 from './pdq8/pdq8.svelte'
  import Hfsgs from './hfsgs/hfsgs.svelte'
  import Pdrisk from './pdrisk/pdrisk.svelte'

  // Variables
  let page
  let params

  // Set up the pages to watch for
  router('/', () => page = Default)
	router('/bmi', () => page = Bmi)
  router('/images', () => page = '/images')
  router('/pdq8', () => page = Pdq8)
  router('/hfsgs', () => page = Hfsgs)
  router('/pdrisk', () => page = Pdrisk)

  // Set up the router to start and actively watch for changes
  router.start()
</script>

<main>
	<svelte:component this={page} params={params} />
</main>
